import React, { Component } from "react";
import AccountHistoryLayout from "home/components/account-history-layout";
import { apiFetch } from "apiFetch";
import { toast } from "react-toastify";

let errorMessage = "An error occured, please try again later";

class AccountHistory extends Component {
  componentDidMount() {
    const url = `/api/plans/${this.props.currentPlan.paymentId}/payments`;

    apiFetch(url, {method: "GET"})
      .then(data => {
        this.setState({
          accountHistory: data
        });
      })
      .catch(() => {
        toast.error(errorMessage);
        this.props.handleShow("AccountHistory", false);
      })
  }

  render() {
    return (
      <AccountHistoryLayout
        {...this.state}
        show={this.props.show || true}
        handleShow={this.props.handleShow}
        currentPlan={this.props.currentPlan}
      />
    );
  }
}

export default AccountHistory;



// WEBPACK FOOTER //
// ./src/home/containers/account-history.js